(function(window, document, $){
	"use strict";

	var $window = $(window),
			$document = $(document),
			$body = $('body');

	var App = function(){
			this.path = $('body').attr("data-path");
			this.ajaxURL = '/wp-admin/admin-ajax.php';


			var app = this;
	};

	App.prototype = {
			onReady : function(){
					this.setGlobals();
					this.autoHandleEvents( $('[data-func]') );


			},
			setGlobals : function(){
					$body = $('body');
			},
			autoHandleEvents : function( $elements ){
					if( !$elements || !$elements.length ){ return false; }

					var self = this;

					$elements.each(function(i,el){
							var func = el.getAttribute('data-func') || false,
									evts = el.getAttribute('data-events') || 'click.customStuff';

							if( func && typeof( self[func] ) === 'function' ){
									$(el)
											.off(evts)
											.on(evts, $.proxy(self[func], self))
											.attr('data-delegated', 'true');
							}
					});
			},
			showTarget : function( event ){
					event.preventDefault();
					$target = $('#' + event.currentTarget.getAttribute('data-target')).show();
			},
			showTab : function( event ){
					event.preventDefault();
					var $item = $(event.currentTarget);

					$('[data-tabname="'+ $item.data('target') +'"]').addClass('active').siblings().removeClass('active');
					$item.addClass('active').siblings().removeClass('active');
			}
	};

	var app = new App();
	$document.ready(function(){ app.onReady && app.onReady(); });

}(window, document, jQuery));
